import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from './Layout';


const Performance = () => {
  const navigate = useNavigate();

  const handleGraphClick = () => {
    navigate('/graphView');
  };

  const handleTableClick = () => {
    navigate('/tableView');
  };

  return (
    <Layout>
      <div className="container mt-5">
        <div className="row justify-content-center">
        <div className="col-md-4 d-flex justify-content-center mb-3">
          <button
            className="btn btn-lg w-100"
            style={{ backgroundColor: 'yellow', color: 'black' }}
            onClick={handleGraphClick}
          >
            Graph View
          </button>
        </div>
        <div className="col-md-4 d-flex justify-content-center mb-3">
          <button
            className="btn btn-lg w-100"
            style={{ backgroundColor: 'green', color: 'white' }}
            onClick={handleTableClick}
          >
            Table View 
          </button>
        </div>
        </div>
      </div>
    </Layout>
  );
};

export default Performance;
